var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"get-token-container"},[_c('a-spin',{attrs:{"spinning":_vm.loading,"tip":("" + (_vm.$t('goToOAuth'))),"size":"large"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }